import { render, staticRenderFns } from "./Events_main.vue?vue&type=template&id=699db68a&scoped=true&"
import script from "./Events_main.vue?vue&type=script&lang=js&"
export * from "./Events_main.vue?vue&type=script&lang=js&"
import style0 from "./Events_main.vue?vue&type=style&index=0&id=699db68a&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699db68a",
  null
  
)

export default component.exports